module.exports = __webpack_public_path__ + "img/website.7256d902.svg";